export default "__VITE_ASSET__DIzi4D4C__"